/** Réglages du fond Matrix (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    colonnes: {
        type: "nombre", libelle: "Nombre de colonnes", min: 16, max: 100, pas: 2, defaut: 64,
        aide: "Plus il y en a, plus la pluie est dense. Au-delà de 64, l'écran travaille un peu plus.",
    },
    vitesse: {
        type: "nombre", libelle: "Vitesse de chute", min: 0.5, max: 3, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    taille: {
        type: "nombre", libelle: "Taille des caractères", min: 0.7, max: 1.6, pas: 0.1, defaut: 1, unite: "×",
        aide: "Des caractères plus grands se lisent de plus loin, mais les colonnes se chevauchent plus.",
    },
    couleur: {
        type: "choix", libelle: "Couleur de la pluie", defaut: "vert",
        options: [
            {valeur: "vert", libelle: "Vert (Matrix)"},
            {valeur: "bleu", libelle: "Bleu"},
            {valeur: "ambre", libelle: "Ambre"},
            {valeur: "rouge", libelle: "Rouge"},
            {valeur: "violet", libelle: "Violet"},
        ],
    },
};
